/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_File_Read_ErrorInputs */

const es_tools_nexata_file_read_error = /** @type {(inputs: Tools_Nexata_File_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al leer archivo`)
};

const en_tools_nexata_file_read_error = /** @type {(inputs: Tools_Nexata_File_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error reading file`)
};

/**
* | output |
* | --- |
* | "Error reading file" |
*
* @param {Tools_Nexata_File_Read_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_file_read_error = /** @type {((inputs?: Tools_Nexata_File_Read_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_File_Read_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_file_read_error(inputs)
	return en_tools_nexata_file_read_error(inputs)
});
export { tools_nexata_file_read_error as "tools.nexata.file_read_error" }